<template>
  <div class="main">
    <router-view class="content" />
  </div>
</template>

<script>
  export default {
    name: 'Blank',
  }
</script>

<style scoped>
  .content {
    height: 100vh;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/layout/blank.vue